<template xmlns:v-bind="http://www.w3.org/1999/xhtml">
  <div class="container-fluid">
    <div class="row signup-page standard_reg whiteandround">
      <div class="col-lg-12">
        <div class="signup-page--right">
          <div class="form-help">
            <div class="row inner_logo">
              <img :src="getTranslations.logo_for_branded_projects || 'static/images/logo.svg'" alt="">
            </div>
            <span>{{ getTranslations.visitor_sign_up_2_2steps_left }}</span>
          </div>
          <div class="col-lg-12">
            <div class="StandardRegSteps_Container" v-if="!hasStepsToDisplay">
              <div class="StandardRegSteps_step step_done">1</div>
              <div class="StandardRegSteps_step">2</div>
              <div class="StandardRegSteps_step inactive">3</div>
            </div>
            <div class="twoStepRegSteps_Container" v-else>
              <div class="twoStepRegSteps_step step_done">1</div>
              <div class="twoStepRegSteps_step">2</div>
            </div>
          </div>
          <div class="signup-form">
            <div class="form-help">
              <img class="form-help__icon"
                   src="static/images/icon-mobile-pin.svg"
                   alt="">
              <p>{{ getTranslations.visitor_sign_up_2_info_msg_unique_code_send }}</p>
            </div>
            <form action="">
              <div class="form-group"
                   :class="[ !hasErrors ? '' : 'has-warning' ]">
                <input type="text"
                       class="form-group__textfield phone_input"
                       :class="[ !hasErrors ? 'has-success' : 'has-warning' ]"
                       :placeholder="getTranslations.visitor_sign_up_2_validation_code"
                       @keyup="check"
                       v-model="user.pin"/>
                <span v-show="getMessage(message) && user.pin"
                      class="form-group__feedback">{{ getMessage(message) }}
                </span>
              </div>
              <div class="form-footer">
                {{ getTranslations.visitor_sign_up_3_info_msg_agree_to_terms }} <br><a>
                <a :href="getTranslationByOperator(multiOperatorInfo.multiOperatorOrdinal, 'project_config_visitor_register_3_terms_and_conditions')" target="_blank">{{ getTranslations.visitor_sign_up_3_terms_and_conditions }}</a>
              </a>
              </div>

              <p v-if="displayPrice">{{ getTranslationByOperator(multiOperatorInfo.multiOperatorOrdinal, 'project_config_visitor_register_2_price') }}</p>

              <input type="submit"
                     :value="getTranslations.visitor_sign_up_2_submit_button_continue"
                     :class="['btn btn--medium btn--main' , ( hasErrors || waitForResponse ? 'deactivated' : '')]"
                     @click.prevent="checkButton">
              <br/>
              <br/>
              <a href="https://www.google.com" v-if="!checkIfTranslationEmptyByOrdinal(multiOperatorInfo.multiOperatorOrdinal, 'project_config_visitor_register_2_exit')">
                {{ getTranslationByOperator(multiOperatorInfo.multiOperatorOrdinal, 'project_config_visitor_register_2_exit') }}
              </a>
              <br/>
              <br/>
              <ul v-if="hasSimplify()"
                  class="alter_flow_list form-group__feedback reg_notice">
                <li v-for="(key, index) in disclaimers"
                    v-if="getTranslations[key]"
                    :key="index">
                  {{ getTranslations[key] }}
                </li>
              </ul>
              <div class="form-group form-group--mobile">
                <span v-if="!checkIfTranslationEmptyByOrdinal(multiOperatorInfo.multiOperatorOrdinal, 'project_config_visitor_register_3_reg_notice')"
                      class="form-group__feedback reg_notice">* {{ getTranslationByOperator(multiOperatorInfo.multiOperatorOrdinal, 'project_config_visitor_register_3_reg_notice') }}
                </span>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapState, mapActions } from 'vuex';
import RegistrationFlowMixin from '@/common/mixins/flow';
import IntegrationMixin from '@/common/mixins/integration';

export default {
  name: 'sign-up-2',
  mixins: [IntegrationMixin, RegistrationFlowMixin],
  data() {
    return {
      user: {
        pin: '',
        msisdn: '',
      },
      message: '',
      hasErrors: false,
      blacklistWords: [],
      waitForResponse: false,
      hasStepsToDisplay: false,
      disclaimers: ['visitor_sign_up_disclaimer_text1', 'visitor_sign_up_disclaimer_text2', 'visitor_sign_up_disclaimer_text3', 'visitor_sign_up_disclaimer_text4'],
    };
  },
  created() {
    this.hasStepsToDisplay = this.hasSteps();
    const inputMsisdn = sessionStorage.getItem('msisdn') || this.$route.query.userMsisdn || this.$route.query.msisdn;
    if (inputMsisdn) this.setRegistrationInfo(inputMsisdn);
    const operator = this.$route.query.operator;
    if (operator) {
      this.storeOperator(operator);
      this.$axios.get(`publicapi/getMultiOperatorConfigProperties?operatorKey=${operator}`).then((response) => {
        this.updateMultiOperatorOrdinal({ value: response.data.data.multiOperatorOrdinal });
        this.setDisplayPrice({ value: response.data.data.displayPrice });
      });
    }
  },
  methods: {
    ...mapActions('common', [
      'storeOperator',
    ]),
    ...mapMutations('profile', [
      'setRegistrationInfo',
    ]),
    ...mapMutations('common', [
      'updateMultiOperatorOrdinal',
      'setDisplayPrice',
    ]),
    getMessage(key) {
      if (key === 'SERVER_ERROR') return key;
      return this.getTranslationByOperator(this.multiOperatorInfo.multiOperatorOrdinal, key) || '';
    },
    checkIfTranslationEmptyByOrdinal(ordinal, key) {
      const indexKey = (ordinal ? `${key}.${ordinal}` : key);
      return !this.getTranslations[indexKey];
    },
    sendNewCode() {
      this.$axios.get(`api/requestPin?msisdn=${encodeURIComponent(this.getRegistrationInfo)}&lang=${this.getLocale}`).then((response) => {
        const res = response.data.responseEnum;
        if (res === 'OPERATION_SUCCESS') {
          this.$router.push('register2');
        } else {
          if (res === 'MSISDN_INVALID') {
            this.message = 'visitor_sign_up_invalid_msisdn_msg';
          } else if (res === 'ALREADY_REGISTERED') {
            this.message = 'visitor_sign_up_msisdn_already_registered';
          } else if (res === 'MSISDN_NOT_EXIST') {
            this.message = 'visitor_sign_up_msisdn_not_exists';
          } else if (res === 'MSISDN_BLACKLISTED') {
            this.message = 'visitor_sign_up_msisdn_blacklisted';
          } else if (res === 'BLOCKED_USER') {
            this.message = 'visitor_forgot_password_warning_msd_max_attempts';
          } else if (res === 'SERVER_ERROR') {
            this.message = 'home_profile_profile_edit_server_unvailable';
          } else if ((res === 'THIRD_PARTY_PIN_REQUEST_FAILED') || (res === 'THIRD_PARTY_PIN_VERIFICATION_FAILED') || (res === 'THIRD_PARTY_SUBSCRIPTION_PIN_REQUEST_FAILED')) {
            this.message = 'visitor_sign_up_warning_third_party_error';
          }
          this.hasErrors = true;
        }
      });
    },
    check: function check() {
      const validPinRegex = /^[0-9]{0,8}$/;
      const validPin = this.user.pin.match(validPinRegex);
      if (!validPin) {
        this.message = 'visitor_sign_up_2_warning_msg_wrong_verification_code';
        this.hasErrors = true;
      } else {
        this.hasErrors = false;
        this.message = '';
      }
    },
    checkButton() {
      if (this.user.pin.length >= 4 && this.user.pin.length <= 8 && !this.hasErrors) {
        this.message = '';
        this.waitForResponse = true;
        const alternateVerifyStep = this.getAlternateVerifyPinAction();
        if (alternateVerifyStep) {
          alternateVerifyStep.call(this);
        } else {
          this.getNextRegistrationStep()();
        }
      } else {
        this.message = 'visitor_sign_up_2_warning_msg_wrong_verification_code';
        this.hasErrors = true;
      }
    },
  },
  computed: {
    ...mapState('common', [
      'refUrl',
      'clickid',
      'multiOperatorInfo',
      'displayPrice',
    ]),
    ...mapState('profile', [
      'registrationInfoMsisdn',
    ]),
    ...mapGetters('i18n', [
      'getTranslations',
      'getTranslationByOperator',
      'getLocale',
    ]),
    ...mapGetters('common', [
      'getRefUrl',
      'getClickId',
      'getCampaignId',
      'getPublisherId',
    ]),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/visitor/signup/SignUp2.vue